import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LandingNavbar from '../../components/LandingNavbar';
import LandingFooter from '../../components/LandingFooter';
import '../LandingPage.css';

const UdhariManagementApp = () => {
  return (
    <div className="seo-page">
      <Helmet>
        <title>Udhari Management App | Lena Dena Hisab Kitab | Hisab OK Hai</title>
        <meta name="description" content="Udhari ka hisab kitab rakhna hua aasaan. Track karein kaun kitna lena hai, kitna dena hai. Vendor-wise, person-wise records. Reminders ke saath kabhi nahi bhoolenge." />
        <meta name="keywords" content="udhari management app, lena dena app, hisab kitab app, udhari tracker, payable receivable tracker india, vendor udhari management" />
        <link rel="canonical" href="https://hisabokhai.in/udhari-management-app" />
      </Helmet>

      <LandingNavbar />

      <section className="seo-page-hero">
        <h1>Udhari Management App — Lena Dena Ka Complete Hisab</h1>
        <p>Kaun kitna lena hai, kitna dena hai — sab clear. Vendor-wise tracking aur reminders ke saath kabhi nahi bhoolenge.</p>
        <Link to="/signup" className="cta-primary">Free Mein Try Karein</Link>
      </section>

      <div className="seo-content">
        <h2>Udhari Track Karna Kyun Zaroori Hai?</h2>
        <p>
          India mein udhari (payable/receivable) daily life ka hissa hai — kirana wale se, dost se, rishtedar se.
          Par jab hisab nahi hota toh rishte kharab hote hain aur paisa doobta hai. Ek organized system chahiye
          jo har lena-dena record kare.
        </p>

        <h2>Hisab OK Hai Se Udhari Manage Karein</h2>
        <p>
          Hisab OK Hai sirf expense tracker nahi hai — yeh ek complete udhari aur vendor management system hai.
        </p>
        <ul>
          <li>Vendor-wise udhari tracking — kirana, dhobi, electrician sab ka record</li>
          <li>Payable aur receivable dono manage karein</li>
          <li>Payment reminders set karein — kabhi nahi bhoolenge</li>
          <li>Transaction history dekho — kaun kitna kab diya</li>
          <li>Multiple ledgers mein organize karein</li>
          <li>Reports mein total udhari summary dekho</li>
        </ul>

        <h2>Vendor Tracking Feature</h2>
        <p>
          Har vendor ka alag record rakhein. Kitna diya, kitna baaki hai — ek nazar mein clear.
          Regular vendors ke liye recurring entries set karein aur payment history track karein.
        </p>

        <h2>Reminders Jo Bhoolne Na Dein</h2>
        <p>
          Payment due date aane se pehle reminder milega. One-time ya recurring — dono type ke reminders set kar sakte ho.
          Kabhi koi payment miss nahi hogi.
        </p>

        <div className="seo-cta-box">
          <h3>Try Hisab OK Hai for Free</h3>
          <p style={{color: '#555', marginBottom: '16px'}}>Udhari ka tension khatam karein — abhi shuru karein, bilkul free.</p>
          <Link to="/signup" className="cta-primary">Free Sign Up</Link>
          <div style={{marginTop: '12px'}}>
            <Link to="/login" style={{color: '#27AE60', fontSize: '0.9rem'}}>Already have an account? Login</Link>
          </div>
        </div>

        <div className="seo-internal-links">
          <h3>Explore More Features</h3>
          <div className="seo-links-grid">
            <Link to="/" className="seo-link-card">
              <span className="seo-link-icon">&#127968;</span> Home
            </Link>
            <Link to="/expense-tracker-india" className="seo-link-card">
              <span className="seo-link-icon">&#128176;</span> Expense Tracker
            </Link>
            <Link to="/daily-expense-tracker" className="seo-link-card">
              <span className="seo-link-icon">&#128197;</span> Daily Expense Tracker
            </Link>
            <Link to="/budget-planner-india" className="seo-link-card">
              <span className="seo-link-icon">&#128200;</span> Budget Planner
            </Link>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default UdhariManagementApp;
